import avatarIcon from "./avater-icon.png";
import defaultAvatar from "./default-avatar.png";
import geminiIcon from "./gemini_sparkle_blue_33c17e77c4ebbdd9490b683b9812247e257b6f70.svg";
import advanceGeminiIcon from "./gemini_sparkle_red_4ed1cbfcbc6c9e84c31b987da73fc4168aec8445.svg";
// import chatGeminiIcon from "./bard_sparkle_v2.svg";
import geminiLaoder from "./bard_sparkle_processing_v2_loader.gif";
import fullLogo from "./gtruth-logo.png";
import fullLogo2 from "./gtruth-logo2.png";
import flightIcon from "./icons8-flight-64.png";
import googleBigIcon from "./icons8-google-144.png";
import googleLogo from "./icons8-google-48.png";
import mapIcon from "./icons8-google-maps-48.png";
import hotelIcon from "./icons8-hotel-48.png";
import sportsIcon from "./icons8-man-winner-48.png";
import ytIcon from "./icons8-youtube-48.png";
import chatGeminiIcon from "./logo.png";

import { darkIcon } from "./darkIcon/darkIcon";
import { lightIcon } from "./lightIcon/lightIcon";

import chatIntro1 from "./chat-introduce1.png";
import chatIntro2 from "./chat-introduce2.webp";
import chatIntro3 from "./chat-introduce3.webp";
import addtIcon from "./icons/add.png";
import emailIcon from "./icons/email.png";
import successIcon from "./icons/icons8-success-480.png";
import menuIcon from "./icons/menu.png";
import sendIcon from "./icons/send.png";
import stopIcon from "./icons/stop.png";
import threedottIcon from "./icons/threedot.png";

import tutorialIcon from "./tutorial/2547-logo-youtube.gif";
import icons8HelpGuide from "./icons8-guide-100.png";

import goldNoSound from "./icons/gold-no-sound.png";
import goldSound from "./icons/gold-sound.png";
import isCloseEye from "./icons/i-closed-eye.svg";
import isOpenEye from "./icons/i-open-eye.svg";
import mixingAudioIcon from "./icons/volume_sound.png";
import feedbackIcon from "./icons/feedback.png";

export const commonIcon = {
  geminiIcon,
  advanceGeminiIcon,
  avatarIcon,
  chatGeminiIcon,
  geminiLaoder,
  googleLogo,
  ytIcon,
  flightIcon,
  mapIcon,
  hotelIcon,
  googleBigIcon,
  defaultAvatar,
  sendIcon,
  menuIcon,
  threedottIcon,
  addtIcon,
  stopIcon,
  chatIntro1,
  chatIntro2,
  chatIntro3,
  fullLogo,
  fullLogo2,
  emailIcon,
  successIcon,
  tutorialIcon,
  goldSound,
  goldNoSound,
  isOpenEye,
  isCloseEye,
  mixingAudioIcon,
  feedbackIcon,
  icons8HelpGuide,
};

export const themeIcon = () => {
  const localTheme = localStorage.getItem("theme") || "light";
  const icon = localTheme === "dark" ? darkIcon : lightIcon;

  return icon;
};

// export const suggestPrompt = [
//   {
//     id: 1,
//     sort: "Where is heaven?",
//     long: "Where is heaven?",
//     icon: "ideaIcon",
//   },
//   {
//     id: 2,
//     sort: "What is the meaning of salvation?",
//     long: "What is the meaning of salvation?",
//     icon: "codeIcon",
//   },
//   {
//     id: 3,
//     sort: "Can we ever be confident that we will be saved?",
//     long: "Can we ever be confident that we will be saved?",
//     icon: "ideaIcon",
//   },
//   {
//     id: 4,
//     sort: "What role does faith play in salvation?",
//     long: "What role does faith play in salvation?",
//     icon: "ideaIcon",
//   },
//   {
//     id: 5,
//     sort: "Is salvation by faith alone, or do works matter?",
//     long: "Is salvation by faith alone, or do works matter?",
//     icon: "navigateIcon",
//   },
//   {
//     id: 6,
//     sort: "What does the Bible say about eternal life?",
//     long: "What does the Bible say about eternal life?",
//     icon: "ideaIcon",
//   },
//   {
//     id: 7,
//     sort: "Can someone lose their salvation?",
//     long: "Can someone lose their salvation?",
//     icon: "navigateIcon",
//   },
//   {
//     id: 9,
//     sort: "How does one repent and be forgiven for their sins?",
//     long: "How does one repent and be forgiven for their sins?",
//     icon: "writeIcon",
//   },
//   {
//     id: 10,
//     sort: "What are the signs of being saved?",
//     long: "What are the signs of being saved?",
//     icon: "ideaIcon",
//   },
//   {
//     id: 11,
//     sort: "How does grace relate to salvation?",
//     long: "How does grace relate to salvation?",
//     icon: "writeIcon",
//   },
//   {
//     id: 12,
//     sort: 'What does it mean to be "born again"?',
//     long: 'What does it mean to be "born again"?',
//     icon: sportsIcon,
//   },
//   {
//     id: 13,
//     sort: "What is the significance of Jesus in the process of salvation?",
//     long: "What is the significance of Jesus in the process of salvation?",
//     icon: "writeIcon",
//   },
// ];

export const suggestPrompt = [
  {
    id: 1,
    sort: "What role does faith play in receiving God’s grace?",
    long: "What role does faith play in receiving God’s grace?",
    icon: "ideaIcon",
  },
  {
    id: 2,
    sort: "Is salvation possible without unwavering faith?",
    long: "Is salvation possible without unwavering faith?",
    icon: "codeIcon",
  },
  {
    id: 3,
    sort: "How does true faith transform a believer’s life?",
    long: "How does true faith transform a believer’s life?",
    icon: "ideaIcon",
  },
  {
    id: 4,
    sort: "Can faith grow even after salvation?",
    long: "Can faith grow even after salvation?",
    icon: "ideaIcon",
  },
  {
    id: 5,
    sort: "What’s the difference between believing in God and having saving faith?",
    long: "What’s the difference between believing in God and having saving faith?",
    icon: "navigateIcon",
  },
  {
    id: 6,
    sort: "Why is faith the key to pleasing God?",
    long: "Why is faith the key to pleasing God?",
    icon: "ideaIcon",
  },
  {
    id: 7,
    sort: "How do works relate to faith in the context of salvation?",
    long: "How do works relate to faith in the context of salvation?",
    icon: "navigateIcon",
  },
  {
    id: 9,
    sort: "Is doubt the opposite of faith—or a part of it?",
    long: "Is doubt the opposite of faith—or a part of it?",
    icon: "writeIcon",
  },
  {
    id: 10,
    sort: "Can someone have faith and still feel distant from God?",
    long: "Can someone have faith and still feel distant from God?",
    icon: "ideaIcon",
  },
  {
    id: 11,
    sort: "How does faith sustain us in seasons of silence?",
    long: "How does faith sustain us in seasons of silence?",
    icon: "writeIcon",
  },
  {
    id: 12,
    sort: "What does it mean to walk by faith and not by sight?",
    long: "What does it mean to walk by faith and not by sight?",
    icon: sportsIcon,
  },
  {
    id: 13,
    sort: "Is faith a decision or a gift?",
    long: "Is faith a decision or a gift?",
    icon: "writeIcon",
  },
  {
    id: 14,
    sort: "How did the heroes of faith in Hebrews 11 demonstrate saving trust?",
    long: "How did the heroes of faith in Hebrews 11 demonstrate saving trust?",
    icon: "writeIcon",
  },
  {
    id: 15,
    sort: "Can faith be tested—and still stand firm?",
    long: "Can faith be tested—and still stand firm?",
    icon: "writeIcon",
  },
  {
    id: 16,
    sort: "How does faith anchor us in the storms of life?",
    long: "How does faith anchor us in the storms of life?",
    icon: "writeIcon",
  },
  {
    id: 17,
    sort: "What does it mean to be justified by faith alone?",
    long: "What does it mean to be justified by faith alone?",
    icon: "writeIcon",
  },
  {
    id: 18,
    sort: "How can faith overcome fear in the believer’s heart?",
    long: "How can faith overcome fear in the believer’s heart?",
    icon: "writeIcon",
  },
  {
    id: 19,
    sort: "What are the fruits of genuine faith in Christ?",
    long: "What are the fruits of genuine faith in Christ?",
    icon: "writeIcon",
  },
  {
    id: 20,
    sort: "Why is faith essential when God’s promises seem delayed?",
    long: "Why is faith essential when God’s promises seem delayed?",
    icon: "writeIcon",
  },
  {
    id: 21,
    sort: "How can we grow our faith in a world full of unbelief?",
    long: "How can we grow our faith in a world full of unbelief?",
    icon: "writeIcon",
  },
];
